<template>
<div class="admin-page">
    <!-- 側邊導航欄 -->
    <aside class="sidebar">
      <div class="logo">
        <img src="@/assets/picture/AW LOGO.png" alt="LOGO" />
      </div>
      <nav class="nav-buttons">

        <router-link to="/admin/dashboard" class="nav-button" exact-active-class="active">
          <i class="fa-solid fa-house" style="font-size: 20px; margin-right: 6px;"></i>
          後台首頁
        </router-link>

        <router-link to="/admin/users" class="nav-button" exact-active-class="active">
          <i class="fa-regular fa-pen-to-square" style="font-size: 20px; margin-right: 6px;"></i>
          會員管理
        </router-link>

        <router-link to="/admin/orders" class="nav-button" exact-active-class="active">
          <i class="fas fa-clipboard-check" style="font-size: 20px; margin-right: 6px;"></i>
          訂單管理
        </router-link>

        <router-link to="/admin/rooms" class="nav-button" exact-active-class="active">
          <i class="fas fa-bookmark" style="font-size: 20px; margin-right: 6px;"></i>
          房間管理
        </router-link>

        <router-link to="/admin/springs" class="nav-button" exact-active-class="active">
          <i class="fas fa-bookmark" style="font-size: 20px; margin-right: 6px;"></i>
          湯屋管理
        </router-link>

        <router-link to="/admin/discounts" class="nav-button" exact-active-class="active">
          <i class="fas fa-tag" style="font-size: 20px; margin-right: 6px;"></i>
          優惠管理
        </router-link>

        <router-link to="/admin/posts" class="nav-button"  exact-active-class="active">
          <i class="fas fa-bell" style="font-size: 20px; margin-right: 6px;"></i>
          公告管理
        </router-link>

        <router-link to="/admin/contactus" class="nav-button"  exact-active-class="active">
          <i class="fa-solid fa-envelope" style="font-size: 20px; margin-right: 6px;"></i>
          客戶意見
        </router-link>

        <router-link to="/admin/employees" class="nav-button" exact-active-class="active"> 
          <i class="fas fa-id-card" style="font-size: 20px; margin-right: 6px;"></i>
          員工管理
        </router-link>
      </nav>
      
        <!-- 回首頁按鈕 -->
        <button class="gohome-button" @click="goHome">回首頁</button>
        <!-- 登出按鈕 -->
        <button class="logout-button" @click="handleLogout">登出</button>
    </aside>

    <!-- 主內容區 -->
      <main class="main-content">
        <!-- 右上角顯示登入用戶 -->
        <div class="user-info">
          <p>歡迎：{{ currentUser }}</p> <!--currentUser 判斷是哪個使用者登入會顯示 -->
      </div>
      <router-view /> <!-- 用於顯示子路由對應的內容 -->
    </main>
  </div>

  
</template>

<script>
// 匯入 AdminDashboard 邏輯
import backGroundPageLogic from "@/assets/js/background/BackGroundPage.js";

export default {
  name: "BackGroundPage",
  mixins: [backGroundPageLogic], // 使用 mixins 將邏輯混入組件
};
</script>

<style src="@/assets/css/background/BackGroundPage.css" scoped></style>